import { memo } from 'react';
import { ScrollArea, Timeline, Text, Stack } from '@mantine/core';
import { motion, AnimatePresence } from 'framer-motion';
import { 
    IconTriangleFilled, IconDiamondFilled, IconCircleFilled, IconSquareFilled, 
    IconTrophy, IconAlertTriangle, IconClock, IconInfoCircle, IconList 
} from '@tabler/icons-react';

/**
 * TimelinePanel component displays a scrollable feed of live game events.
 */
const TimelinePanel = memo(({ timeline, colors }) => {
    const answerIcons = [IconTriangleFilled, IconDiamondFilled, IconCircleFilled, IconSquareFilled];

    return (
        <ScrollArea h={320} type="auto" offsetScrollbars>
            <Timeline active={-1} bulletSize={28} lineWidth={2} p="md" pl={40}>
                <AnimatePresence mode="popLayout">
                    {timeline.map((item, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, x: -10 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0 }}
                            layout
                            style={{ marginBottom: 15, paddingBottom: 15, borderBottom: '1px solid var(--mantine-color-dark-4)' }}
                        >
                            <Timeline.Item
                                title={<Text size="sm" fw={700} c="white">{item.title}</Text>}
                                bullet={
                                    item.type === 'answer' ? (
                                        (() => {
                                            const Icon = answerIcons[item.data];
                                            return <Icon size={12} color={colors[item.data]} />;
                                        })()
                                    ) :
                                    item.type === 'success' ? <IconTrophy size={14} color="yellow" /> : 
                                    item.type === 'error' ? <IconAlertTriangle size={14} color="red" /> : 
                                    item.type === 'warning' ? <IconClock size={14} color="orange" /> :
                                    <IconInfoCircle size={14} color="blue" />
                                }
                                color="dark.4"
                            >
                                <Text c="dimmed" size="xs" lh={1.4}>{item.message}</Text>
                                <Text size="xs" mt={4} c="dark.3" fw={500}>{item.time}</Text>
                            </Timeline.Item>
                        </motion.div>
                    ))}
                    {timeline.length === 0 && (
                        <Stack align="center" py="xl" gap="xs">
                            <IconList size={32} color="var(--mantine-color-dark-4)" />
                            <Text size="sm" c="dimmed">Waiting for events...</Text>
                        </Stack>
                    )}
                </AnimatePresence>
            </Timeline>
        </ScrollArea>
    );
});

export default TimelinePanel;
